import {
  ScaffolderFormHeader,
  ScaffolderFormPaper,
} from '@internal/plugin-scaffolder-common-field-react';
import React, { useEffect, useRef } from 'react';

import { SourcePicker } from '../components/SourcePicker';
import { SOURCE_INFO } from '../infoDoc';
import { SourceConfiguration } from '../types';

interface ApplicationSourceSectionProps {
  value: SourceConfiguration | null;
  onChange: (value: SourceConfiguration | null) => void;
  errors: string[];
}

const ApplicationSourceSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSourceSectionProps) => {
  const hasErrors = errors.length > 0;
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasErrors) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [hasErrors]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <ScaffolderFormHeader
          title="Source"
          description="Configure the source for this Application's deployment."
          divider
          infoDoc={SOURCE_INFO}
        />
        <SourcePicker value={value} onChange={onChange} errors={errors} />
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSourceSection = React.memo(
  ApplicationSourceSectionInner,
);
